exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.badgeLoading .v-skeleton-loader__heading {\n    margin-top: 0 !important;\n    width: 24px !important;\n}\n\n", ""]);
